// @flow
import React from 'react';

import Card from './Card';
import ProviderHeader from './ProviderHeader';
import ProviderAddress from './ProviderAddress';
import ProviderStatus from './ProviderStatus';
import ConsentForm from './ConsentFormLink';
import PatientEducation from './PatientEducation';
import HelpYourself from './HelpYourself';

import { AllStatusesStore } from '../../types/status';
import { InstitutionWithAddresses } from '../../types/institution';

type Props = {
  className?: string,
  types: Array,
  name: string,
  institution: InstitutionWithAddresses,
  statuses: AllStatusesStore,
  showConsentForm?: () => void
}

const ProviderCard = ({ className = '', types, name, institution, statuses, showConsentForm }: Props) => {
  return (
    <div>
      <ProviderHeader name={name} types={types} />
      {institution && institution.addresses && institution.addresses.map((address, i) => {
        const matchingStatus = statuses && statuses.find((status) => status.id === address.request_id);
        return (
          <Card
            noShadow
            className={`providers__card ${className}`}
            header={<ProviderHeader name={name} types={types} />}
          >
            <div className='providers__card-content'>
              <ProviderAddress address={address} key={i} />
              <ProviderStatus status={matchingStatus} />
              <div className='providers__education'>
                <PatientEducation />
                {address.phone && <HelpYourself name={name} number={address.phone} />}
                <ConsentForm showConsentForm={() => showConsentForm(address.request_id || address.id)} />
              </div>
            </div>
          </Card>);
        })}
    </div>
  );
};

export default ProviderCard;


// WEBPACK FOOTER //
// ./src/components/shared/ProviderCard.js